export const checkPartnoInDatabase = (row, columnDetail, pncRepeatedInDatabase) => {
  if (columnDetail.serializedName === 'partNo') {
    const fieldValue = row[columnDetail.serializedName];
    return pncRepeatedInDatabase.has(fieldValue);
  }
  return false;
};


export const checkRepeatedPrimaryKey = (row, tableValues, serializedName = 'partNo') => {
  const fieldValue = row[serializedName];
  if (serializedName === 'partNo') {
    if (tableValues.length !== 0) {
      const partnoList = tableValues.map((values) => {
        return values.partNo;
      });
      return partnoList.filter((partNo) => {
        return partNo === fieldValue;
      }).length > 1;
    }
  }
  return false;
};

export const isRowInvalid = (row, tableValues) => {
  const numericalFieldConstraints = checkRepeatedPrimaryKey(row, tableValues);
  const requiredConstraints = !row.partNo || !row.product;
  return numericalFieldConstraints || requiredConstraints;
};

export const formatElement = (value, header) => {
  const {maxLength} = header;
  if (!header.maxLength || !value) {
    return value;
  }
  return value.toUpperCase().substring(0, parseInt(maxLength, 10));
};
